import { render } from "./prescription-list.vue?vue&type=template&id=b3a255ce&scoped=true"
import script from "./prescription-list.vue?vue&type=script&lang=js"
export * from "./prescription-list.vue?vue&type=script&lang=js"

import "./prescription-list.vue?vue&type=style&index=0&id=b3a255ce&lang=scss&scoped=true"

import exportComponent from "/builds/gitlab-runner/ci/auto-build/hospital-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a255ce"]])

export default __exports__